const couponsDictPT = {
  specialCustomerRegisterCoupons: "Cupons de Crédito",
  generateCoupon: "Cupom de convite",
  extracoinAmount: "Quantia de crédito Extracredit",
  unexpectedErrorWhileGeneratingCoupon: "Erro inesperado ao gerar cupom de crédito.",
  currency: "Moeda",
  used: "Usado",
  notUsed: "Não usado",
  couponGenerated: "Você gerou um novo cupom de crédito com sucesso!",
  couponCanceled: "Você cancelou a operação para gerar um novo cupom de crédito.",
  areYouSureCoupon:
    "Tem certeza de que deseja gerar um novo cupom de crédito? O valor será debitado do seu saldo Extracredit.",
  confirmYourAction: "Confirme sua ação",
  confirm: "Confirmar",
  usedBy: "Usado por",
  generatedCoupon: "Cupom gerado",
  inviteCouponDialogTitle: "Criação do cupom convite",
  inviteCouponDialogSubtitle: "Envie créditos extras de boas-vindas.",
  inviteCouponSectionBalance: "Saldo Extracredit",
  inviteCouponSectionData: "Dados do cupom",
  inviteCouponAmountLabel: "Insira o valor",
  inviteCouponAmountTooltip: "Valor debitado do seu saldo Extracredit ao criar o cupom.",
  inviteCouponAmountHint: "Use até {balance} ECR",
  inviteCouponBelowMinBalance: "O saldo mínimo para criar um cupom é {min} ECR.",
  inviteCouponCreating: "Aguarde enquanto criamos o cupom.",
  inviteCouponCancel: "Cancelar",
  inviteCouponCreate: "Criar cupom",
  inviteCouponSuccessTitle: "Cupom criado",
  inviteCouponSuccessMeta: "Sucesso • {dateTime}",
  inviteCouponYouUsed: "Utilizou",
  inviteCouponCodeSection: "Código do cupom",
  inviteCouponShareHint:
    "Partilhe este código com o seu convidado. Ele receberá {couponValue} em ECR assim que se registar. Este código só pode ser usado uma vez.",
  inviteCouponFinish: "Concluir",
  inviteCouponErrorGeneric: "Não foi possível criar o cupom. Tente novamente.",
};

export default couponsDictPT;
